package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.MusicNoteW500Rounded: ImageVector
    get() {
        if (_musicNoteW500Rounded != null) {
            return _musicNoteW500Rounded!!
        }
        _musicNoteW500Rounded = Builder(name = "MusicNoteW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(280.54f, 800.41f)
                quadToRelative(-48.67f, -48.67f, -48.67f, -116.82f)
                quadToRelative(0.0f, -68.16f, 48.67f, -116.83f)
                quadToRelative(48.68f, -48.67f, 116.83f, -48.67f)
                quadToRelative(21.33f, 0.0f, 39.39f, 4.78f)
                quadToRelative(18.07f, 4.78f, 35.11f, 14.35f)
                verticalLineToRelative(-380.81f)
                quadToRelative(0.0f, -19.15f, 13.17f, -32.32f)
                quadToRelative(13.18f, -13.18f, 32.33f, -13.18f)
                horizontalLineToRelative(165.5f)
                quadToRelative(19.15f, 0.0f, 32.33f, 13.18f)
                quadToRelative(13.17f, 13.17f, 13.17f, 32.32f)
                verticalLineToRelative(80.0f)
                quadToRelative(0.0f, 19.16f, -13.17f, 32.33f)
                quadToRelative(-13.18f, 13.17f, -32.33f, 13.17f)
                horizontalLineToRelative(-120.0f)
                verticalLineToRelative(401.68f)
                quadToRelative(0.0f, 68.15f, -48.67f, 116.82f)
                quadToRelative(-48.68f, 48.68f, -116.83f, 48.68f)
                reflectiveQuadToRelative(-116.83f, -48.68f)
                close()
            }
        }
        .build()
        return _musicNoteW500Rounded!!
    }

private var _musicNoteW500Rounded: ImageVector? = null
